<template lang="pug">
  v-footer(color='primary', padless, app)
    v-row(justify='center', no-gutters)
      v-col.primary.text-center.white--text(cols='12')
        strong {{ new Date().getFullYear() }} - Micropetid
</template>

<script>
export default {
  name: "Footer"
};
</script>
